import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { singletonGetter } from "@faire/web/dist/common/singletons/getter";
import { createStoreHook } from "@faire/web/ui/hooks/useStore";
import { createBrowserHistory } from "history";
export var AppHistory = /*#__PURE__*/_createClass(function AppHistory() {
  _classCallCheck(this, AppHistory);
  this.history = createBrowserHistory();
});
AppHistory.get = singletonGetter(AppHistory);
export var useAppHistory = createStoreHook(AppHistory);